module.exports = __webpack_public_path__ + "img/times-circle.c919e108.svg";